import { Injectable } from '@angular/core';
import { marked } from 'marked';

@Injectable()
export class MarkdownParser {
  parse(source: string, options: marked.MarkedOptions) {
    return marked(source, options);
  }
}
